import { QueryClient, useMutation } from "react-query";
import { Put } from "../utils/api";
import { useAuth0 } from "@auth0/auth0-react";
import { User } from "../../types/api/User";

export default () => {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = new QueryClient();
  return useMutation<User, null>(
    `create_user`,
    async () => Put(`/api/user/create`, await getAccessTokenSilently(), {}),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([`user`]);
      },
      onError: (error) => {
        // refresh page
        // window.location.reload();
      },
    }
  );
};
